import merge from 'lodash/merge';
import get from 'lodash/get';
import modelTree from "~/selectors/modelTree";
import ensureItemSubviewsAreLoaded from "~/reducers/helpers/ensureSubviewsAreLoaded";

const loadModels = (loadedModels, { models, getModelOrNull, getSubviewsByModelName }) => {
    models.forEach((model) => {
        let {
            modelName,
            data = {},
            parentModelId = null
        } = model;

        let tree = modelTree(loadedModels);
        let modelId = model.modelId ? model.modelId : tree.getTreeId(model.modelName);

        data = {...data, modelName};

        let modelConfig = modelName ? getModelOrNull(modelName) : null,
            modelToLoad = modelConfig ? merge({}, modelConfig.stateModel, data) : data;

        loadedModels = tree.loadModel(modelId, modelToLoad, parentModelId).tree;

        loadedModels = ensureItemSubviewsAreLoaded(loadedModels, {
            parentModelId: modelId,
            itemId: get(data, 'item.id'),
            modelName,
            getModelOrNull,
            getSubviewsByModelName
        });
    });

    return loadedModels;
};

export default loadModels;